// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"82749d00","280":"93dead3d","494":"4d4eb6bc"}[chunkId] + ".chunk.js";
};